import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';

/**
 * 主布局组件 - 飞书兼容顶部导航布局
 *
 * 重构说明：
 * - 移除左侧 Sidebar，解决与飞书侧边栏的双侧边栏冲突
 * - 导航菜单集成到顶部 Header
 * - 内容区全宽响应式，背景色使用飞书标准浅灰 #f5f6f7
 */
const MainLayout: React.FC = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#f5f6f7' }}>
      <Header />

      {/* 主内容区 - pt-14 对应 Header 高度 56px */}
      <main className="pt-14">
        <div className="p-4 sm:p-6 lg:p-8 max-w-[1600px] mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default MainLayout;
